import { motion } from 'framer-motion';

const AntButton = ({
  children,
  variant = 'primary',
  onClick,
  href,
  className = '',
  type = 'button',
  ...props
}) => {
  const base =
    'inline-flex items-center justify-center gap-2 px-6 sm:px-7 py-3.5 rounded-full text-sm font-semibold min-h-[48px] cursor-pointer transition-colors duration-200';

  const variants = {
    primary: 'bg-white text-ant-bg-2 hover:bg-white/90',
    secondary: 'border border-white/15 text-white/70 hover:border-white/30 hover:text-white',
    ghost: 'text-ant-gold/80 hover:text-ant-gold border border-transparent hover:border-ant-gold/30',
  };

  const classes = `${base} ${variants[variant]} ${className}`;
  const motionProps = {
    whileHover: { scale: 1.02 },
    whileTap: { scale: 0.98 },
    transition: { type: 'spring', stiffness: 400, damping: 24 },
  };

  if (href) {
    return (
      <motion.a href={href} className={classes} {...motionProps} {...props}>
        {children}
      </motion.a>
    );
  }

  return (
    <motion.button type={type} onClick={onClick} className={classes} {...motionProps} {...props}>
      {children}
    </motion.button>
  );
};

export default AntButton;